import React, { useState, useEffect } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import colors from '../colors';

const useStyles = makeStyles((theme) => ({
    root: {
        textTransform: 'none', 
        paddingLeft: '40px', 
        paddingRight: '40px', 
        borderRadius: '8px!important',
        fontWeight: 'normal'
    },
    rootCenter: {
        textTransform: 'none', 
        paddingLeft: '40px', 
        paddingRight: '40px', 
        borderRadius: '8px!important',
        fontWeight: 'normal',
        '@media (max-width: 1024px)': {
            display: 'block',
            margin: 'auto'
        },
        display: 'block',
        margin: 'auto'
    }
}));

const ButtonCore = props => {

    const classes = useStyles();

    const [backgroundColor, setBackgroundColor] = useState(colors?.primary)
    const [color, setColor] = useState('#FFF')
    const [border, setBorder] = useState('none')

    const config = () => {

        if(props.variant == 'contained'){
            if(props.color == 'blue'){
                setBackgroundColor(colors?.primary)
            }else if(props.color == 'orange'){
                setBackgroundColor('#FF4E02')
            }else if(props.color == 'red'){
                setBackgroundColor('red')
            }else if(props.color == 'white'){
                setBackgroundColor('#FFF')
                setColor(colors?.primary)
            }else{
                setBackgroundColor(colors?.primary)
            }
            if(props.color != 'white'){
                setColor('#FFF')
            }
        }else if(props.variant == 'outlined'){
            if(props.color == 'blue'){
                setColor(colors?.primary)
                setBorder(`1px solid ${colors?.primary}`)
            }else if(props.color == 'orange'){
                setColor('#FF4E02')
                setBorder('1px solid #FF4E02')
            }else if(props.color == 'red'){
                setColor('#FF4E02')
                setBorder('1px solid red')
            }else if(props.color == 'white'){
                setColor(colors?.primary)
                setBorder('')
            }else{
                setColor(colors?.primary)
                setBorder(`1px solid ${colors?.primary}`)
            }
            setBackgroundColor('transparent')
        }

    }

    useEffect(() => {
        config()
    }, [props.variant, props.color])

    useEffect(() => {

        if(props.disabled === true){
            setBackgroundColor('#D7D7D7')
            setColor('gray')
            setBorder('')
        }else{
            config()
        }

    }, [props.disabled])

    return (
        <>

            <Button 
                variant={props?.variant || 'contained'}
                fullWidth={props.fullWidth ? true : false}
                className={props.cener ? classes.rootCenter : classes.root}
                style={{ 
                    backgroundColor: props.disabled || props.isLoading ? 'rgb(210, 210, 210)' : backgroundColor,
                    border: props.disabled || props.isLoading ? '8px solid rgb(210, 210, 210)' : border,
                    color: props.disabled || props.isLoading ? 'gray' : color,
                    height: props.size == 'small' ? '40px' : '56px',
                    marginTop: props.marginTop && props.marginTop,
                    padding: props.paddingOff && '0px',
                    boxShadow: 'none',
                    paddingLeft: props.disableddHorizontalPadding && '10px',
                    paddingRight: props.disableddHorizontalPadding && '10px',
                    ...props?.style
                }}
                size={props.size || 'large'}
                disabled={props.disabled || props.isLoading}
                onClick={(event) => {
                    if(props.onClick){
                        props.onClick(event)
                    }
                }}
                startIcon={props?.startIcon}
                id={props?.id}
            >
                {!props?.isLoading ? 
                    props.label :
                    <CircularProgress disableShrink style={{ color: '#FFFFFF' }} size={20} thickness={4} />
                }
            </Button>
            
        </>
    );
}

export default ButtonCore;